// Codes the API attaches to a 401 whose session cannot be salvaged. The server
// rejected the session itself rather than the token minted from it, so a
// refresh returns a token carrying the same `auth_time` and fails identically.
// The only way forward is to sign out, which clears Firebase's persisted
// record so the next sign-in can mint a usable token.
//
// `token_expired` is deliberately absent: a refresh does fix that one, and it
// is the ordinary hourly cycle.
const TERMINAL_AUTH_CODES = new Set(["token_revoked", "session_idle"]);

/**
 * Whether a failed response describes a session the client cannot refresh its
 * way out of.
 *
 * Deliberately pure and import-free. It sits on the error path of every
 * authenticated request, and the module that acts on the answer reaches
 * Firebase, the Redux store and antd — pulling that in to answer "no" would
 * load all of it on every network hiccup.
 *
 * Matches on `code`, never on `detail`: detail is prose and will be reworded
 * or localised, so matching it is a contract that breaks silently.
 */
export function isUnrecoverableAuthFailure(status, data) {
  return status === 401 && TERMINAL_AUTH_CODES.has(data?.code);
}
